import { render } from "./InfoWrapper.vue?vue&type=template&id=0d4ac9d7"
import script from "./InfoWrapper.vue?vue&type=script&lang=js"
export * from "./InfoWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__